import React, { useEffect, useMemo, useState } from 'react'

import './FeedPage.css'
import LiveCard from './custom-comp/LiveCard'
import LiveCardVideo from './custom-comp/LiveCardVideo'
import MultiSectionCard from './custom-comp/MultiSectionCard'
import UpcomingEvents from './custom-comp/UpcomingEvents'
import { Link, useNavigate } from 'react-router-dom'
import { useRef } from 'react';
import axios from 'axios'
import LiveCardSkeleton from './custom-comp/LiveCardSkeleton'
import FeedProfileSection from './custom-comp/FeedProfileSection'
import Clogo from "../Navbar/image/logo2.svg"
import FooterAppDownloadModal from './custom-comp/FooterAppDownloadModal'
import BottomFooterModal from './custom-comp/BottomFooterModal'
import { CiSearch } from "react-icons/ci";


import { API_BASE_URL } from "../utils";
import UpcomingPlanModal from './custom-comp/UpcomingPlanModal'
import FeedHorizontalScroll from './custom-comp/FeedHorizontalScroll'
import { Helmet } from 'react-helmet-async'
import { te } from 'date-fns/locale'
import Teaser from '../Club Detail Component/AboutClub/Teaser'

export default function FeedPage() {

  const navigate = useNavigate();

  const url = `${API_BASE_URL}/master/assets/uploads/`;

  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);


  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [visibleCount, setVisibleCount] = useState(6);
  const loaderRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLead, setSelecteLead] = useState(null);

  const slicedEvents = events.slice(0, visibleCount);

  const insertIndexesRef = useRef([]);


  const upcomingRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);

  const [allTeaser, setAllTeaser] = useState([]);



  const categoriesApiUrl = `${API_BASE_URL}/master/Api/getData/eventCategory`;
  const allEventsApiUrl = `${API_BASE_URL}/master/APIs/ClubEvent/allEvents`;

  const categoryWiseEventsApiUrl = `${API_BASE_URL}/master/APIs/ClubEvent/categoryWiseAllEvents`;

  useEffect(() => {
    fetch(categoriesApiUrl)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude.toString());
          setLongitude(longitude.toString());
          fetchAllEvents(latitude, longitude);
        },
        (error) => {
          alert("Please enable Geo Location Service to find events in your locality.");
          console.error('Error in finding location: ', error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);
  const fetchAllEvents = (latitude, longitude) => {
    const formData = new FormData();
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(allEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching all events:", error);
      });
  };
  const fetchEventsByCategory = (latitude, longitude, categoryId) => {
    const formData = new FormData();
    formData.append("category_id", categoryId);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(categoryWiseEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching events by category:", error);
      });
  };


  const category = new FormData();
  category.append("category", "Ambience");

  // Teaser
  useEffect(() => {
    const fetchTeaser = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/master/APIs/Common/getTeaserCategoryWise`,
          category
        );
        if (response.data.status === true) {
          console.log("video", response.data);
          setAllTeaser(response.data.data);
          setIsLoading(false);

        } else {
          console.log("No data found");
        }
      } catch (error) {
        console.log("Error fetching data: ", error);
      }
    };
    fetchTeaser();
  }, []);




  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  function generateClubUrl(item) {
    const { clubName, cityName, areaName, name } = item;
    const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

    return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(name)}`;
  }

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value) {
      navigate(value);
    }
  };


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisibleCount((prev) => prev + 6); // Load next 6
        }
      },
      { threshold: 1 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, []);


  useEffect(() => {
    if (slicedEvents.length >= 6) {
      const indexes = new Set();
      while (indexes.size < Math.min(3, slicedEvents.length - 2)) {
        const idx = Math.floor(Math.random() * (slicedEvents.length - 2)) + 1;
        indexes.add(idx);
      }
      insertIndexesRef.current = [...indexes];
    }
  }, [slicedEvents.length]);


  useEffect(() => {
    if (!upcomingRef.current) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setOffsetTop(entry.contentRect.height);
      }
    });

    observer.observe(upcomingRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);


  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };



  return (
    <>
      <Helmet>
        <meta name="description" content="Book the best party venues, bars, cafés, and top lounges near me in Delhi-NCR. Explore options, get offers & deals with PartyWitty’s booking platform." />
        <meta name="robots" content="all" />
        <meta name="GOOGLEBOT" content="Index, Follow" />
        <meta name="Robots" content="Index, Follow" />
        <meta name="Author" content="Party witty" />
        <meta name="language" content="EN-UK" />
        <meta
          property="og:title"
          content="Party Packages | Corporate Party Places, Cocktail Party Bar,Pubs"
        />
        <meta property="og:site_name" content="PartyWitty" />
        <meta property="og:url" content="https://www.partywitty.com" />
        <meta
          property="og:description"
          content="Party Witty is a Place for Finding Best Party Packages Near You, Party Venues, Liquor Party Packages  Best Deals & Offers Veg & Non Veg Food, cocktail  Party Bar,pubs, Group party halls in Delhi Ncr."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.partywitty.com/static/media/logo.7b353465feb370797c03.png"
        />
        <link rel="canonical" href=" https://www.partywitty.com/ " />
      </Helmet>

      <div className='feed-page'>
        <div className='live-reel-container'>

          <div className='feed-page-pro-section'>
            <FeedProfileSection />
          </div>

          <div className='live-reel-header'>
            <div className='live-reel'>
              {(slicedEvents.length === 0
                ? Array.from({ length: 4 }).map((_, i) => <LiveCardSkeleton key={i} />)
                : shuffleArray(slicedEvents).map((item, index) => (
                  <React.Fragment key={item.id || index}>
                    {insertIndexesRef.current.includes(index) && (
                      <div className="available-packages-box">
                        <FeedHorizontalScroll />
                      </div>
                    )}
                    {insertIndexesRef.current.includes(index + 1) && (
                      <>
                        {allTeaser.map((item, i) => (
                          <LiveCardVideo key={i} data={item} />
                        ))}
                      </>
                    )}
                    <div className="reel-item">
                      <Link to={generateClubUrl(item)}>
                        {item.video ? (
                          <LiveCardVideo data={item} />
                        ) : (
                          <LiveCard data={item} />
                        )}
                      </Link>
                    </div>
                  </React.Fragment>
                ))
              )}



              <div ref={loaderRef} style={{ height: "1px" }} />
            </div>

          </div>

          <div className='f-upcoming-events-section' style={{ position: 'sticky', top: `${-offsetTop + 50}px`, zIndex: 2 }}>
            <div ref={upcomingRef} style={{ display: 'block', width: '100%' }}>
              <UpcomingEvents setModalOpen={setModalOpen} setSelecteLead={setSelecteLead} />
            </div>
            <div className='fues-footer-sec-line' >
              <div className='fues-footer-sec-line-f-line'>
                <div className='fues-footer-sec-line-f-text'></div>
                <div className='fues-footer-sec-line-f-text'></div>
              </div>
              <div className='fues-footer-sec-line-f-links'>

                <Link to="/about-us">
                  <div className='fues-footer-sec-line-f-text-content'>About us</div>
                </Link>

                <Link className='f-link-a' to="/custom-package-services">
                  <div className='fues-footer-sec-line-f-text-content'>services</div>
                </Link>

                <div className='fues-footer-sec-line-f-text-content'>
                  <select
                    id="collections-select-c"
                    name="Collections"
                    className="fues-footer-select"
                    onChange={handleSelectChange}
                    defaultValue=""
                  >
                    <option value="" disabled hidden>
                      Collections
                    </option>
                    <option className='fues-footer-option' value="/party-packages">Packages</option>
                    <option className='fues-footer-option' value="/venues">Venues</option>
                    <option className='fues-footer-option' value="/events">Events</option>
                    <option className='fues-footer-option' value="/artists">Artists</option>
                  </select>
                </div>





                <div className='fues-footer-sec-line-f-text-content'>
                  <select
                    id="collections-select-a"
                    name="Collections"
                    className="fues-footer-select"
                    onChange={handleSelectChange}
                    defaultValue=""
                  >
                    <option value="" disabled hidden>
                      Agreements
                    </option>
                    <option className='fues-footer-option' value="/club-agreement">Club Agreement</option>
                    <option className='fues-footer-option' value="/artist-agreement">artist agreement</option>
                    <option className='fues-footer-option' value="/refund-policy">refund & cancellation policy</option>
                    <option className='fues-footer-option' value="/privacy-policy">privacy policy</option>
                    <option className='fues-footer-option' value="/term-conditions-policy">terms & conditions</option>
                  </select>
                </div>



                <div className='fues-footer-sec-line-f-text-content'>
                  <select
                    id="collections-select-p"
                    name="Collections"
                    className="fues-footer-select"
                    onChange={handleSelectChange}
                    defaultValue=""
                  >
                    <option value="" disabled hidden>
                      Partner with
                    </option>
                    <option className='fues-footer-option' value="/partner-as-an-artist">as an artist</option>
                    <option className='fues-footer-option' value="/partner-with-us">as a business</option>
                  </select>
                </div>



                <Link className='f-link-a' to="/blogs">
                  <div className='fues-footer-sec-line-f-text-content'>blogs</div>
                </Link>
                <Link className='f-link-a' to="/contact-us">
                  <div className='fues-footer-sec-line-f-text-content'> Contact us</div>
                </Link>
                <div className='fues-footer-sec-line-f-text-content' onClick={() => setShowModal(true)}> Get the app</div>
                <div className='fues-footer-sec-line-f-text-content' onClick={() => setIsModalOpen(true)}>more</div>



              </div>
              <div className='fues-footer-sec-line-f-logo-copywrite'>
                <div className='fues-footer-sec-line-f-logo'>
                  <img src={Clogo} alt="Book best party venues" />
                </div>
                <p> AMIRAG HOSPITALITY PVT. LTD © 2025</p>
              </div>
            </div>
          </div>
        </div>


        <div className='feed-page-design-bottom-footer-tags-section'>
          <div className='feed-page-detail-page-design-bottom-footer-tags'>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1>Book the Best Party Venues, Bars, Cafes & Lounges in Delhi-NCR</h1>
              <p>Top-rated party venues, bars, cafés, and lounges in Delhi, Noida, and Gurgaon for birthdays, corporate parties, kitty parties, and weekend hangouts. Whether you’re looking for rooftop lounges, live music cafés, dance floors, or themed party halls, find the perfect place that fits your vibe and budget. Compare packages, explore curated party deals, and book instantly with PartyWitty. Enjoy exclusive offers on private party spaces, couple-friendly lounges, and group bookings across Delhi-NCR. Make your celebrations memorable by booking verified venues with custom food and drink options. Plan your next party effortlessly with our trusted event booking platform. </p>
            </div>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1>Book a Table Instantly at Restaurants, Clubs & Pubs Near You with the Best Offers</h1>
              <p>Book a table instantly at the best restaurants, clubs, and pubs near you with PartyWitty. Whether it’s a birthday, anniversary, corporate event, or casual night out, find the perfect venue that suits your vibe. Explore top-rated places across Delhi-NCR, compare deals, check availability, and reserve your spot in just a few clicks. Get access to exclusive table booking offers and save up to 50% on your party experience. From rooftop lounges to BYOB venues, PartyWitty helps you plan the perfect outing without the hassle. Book now and party your way — effortlessly and affordably.</p>
            </div>
            <div className='feed-page-detail-page-design-bottom-footer-tags-text'>
              <h1> Explore Custom Party Packages with Exclusive Deals & Offers</h1>
              <p>Planning a celebration? PartyWitty helps you explore and book custom party packages at top restaurants, clubs, and lounges across Delhi, Noida, and Gurgaon. Whether it’s a birthday, anniversary, corporate event, or a casual get-together, find the perfect venue that suits your style and budget. Get up to 50% off on exclusive deals, including rooftop lounges, BYOB venues, and dance floors. Customize food and drink menus, check real-time availability, and compare verified listings — all in one place. With PartyWitty, party planning becomes quick, flexible, and effortless. Book now and enjoy unforgettable moments stress-free!</p>
            </div>
          </div>
        </div>

        <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
        <BottomFooterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <UpcomingPlanModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          selectedLead={selectedLead}
        />
      </div >
    </>
  )
}
